import React from 'react'
import instagramBlack from './images/instagram-black.svg'
import facebookBlack from './images/facebook-black.svg'
import youtubeBlack from './images/youtube-black.svg'
import linkedinBlack from './images/linkedin-black.svg'
import tiktokBlack from './images/tiktok-black.svg'
import twitterBlack from './images/twitter-black.svg'
import whatsappBlack from './images/whatsapp.svg'

const iconMaskStyle = (icon) => ({
  WebkitMaskImage: icon.bg(),
  maskImage: icon.bg(),
});

const SocialLinks = (props) => {

    return (

      <div className="social-links-container">
        {
          props.startPage.whatsappNavigation && props.startPage.whatsappNavigation.value != '' &&
          <a className="whatsapp-icon social-link-icon" href={ props.startPage.whatsappNavigation.value } style={iconMaskStyle(whatsappBlack)}></a>
        }
        {
          props.startPage.instagramNavigation && props.startPage.instagramNavigation.value != '' &&
          <a className="instagram-icon social-link-icon" href={ props.startPage.instagramNavigation.value } style={iconMaskStyle(instagramBlack)}></a>
        }

        {
          props.startPage.facebookNavigation && props.startPage.facebookNavigation.value != '' &&
         <a className="facebook-icon social-link-icon" href={ props.startPage.facebookNavigation.value } style={iconMaskStyle(facebookBlack)}></a>
        }

        {
          props.startPage.youtubeNavigation && props.startPage.youtubeNavigation.value != '' &&
          <a className="youtube-icon social-link-icon" href={ props.startPage.youtubeNavigation.value } style={iconMaskStyle(youtubeBlack)}></a>
        }

        {
          props.startPage.linkedinNavigation && props.startPage.linkedinNavigation.value != '' &&
          <a className="linkedin-icon social-link-icon" href={ props.startPage.linkedinNavigation.value } style={iconMaskStyle(linkedinBlack)}></a>
        }

        {
          props.startPage.tiktokNavigation && props.startPage.tiktokNavigation.value != '' &&
          <a className="tiktok-icon social-link-icon" href={ props.startPage.tiktokNavigation.value } style={iconMaskStyle(tiktokBlack)}></a>
        }

        {
          props.startPage.twitterNavigation && props.startPage.twitterNavigation.value != '' &&
          <a className="twitter-icon social-link-icon" href={ props.startPage.twitterNavigation.value } style={iconMaskStyle(twitterBlack)}></a>
        }
         
      </div>
    )
}

export default SocialLinks
